/**
 * collection-no-show.js
 *
 * Controls visibility of products with "no show" tag on collection pages.
 *
 * Behavior:
 * - Default state: Products with [data-no-show] are hidden via CSS
 * - When Packaging Size filter is active: All products become visible
 *
 * This custom element re-initializes on every Shopify section re-render
 * (triggered by filter/sort changes), so it always reflects current state.
 */
class CollectionNoShow extends HTMLElement {
  static observedAttributes = ['data-packaging-size-active'];

  connectedCallback() {
    this.#evaluate();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-packaging-size-active') {
      this.#evaluate();
    }
  }

  #evaluate() {
    const isActive = this.dataset.packagingSizeActive === 'true';
    document.body.classList.toggle('size-filter-active', isActive);
  }
}

customElements.define('collection-no-show', CollectionNoShow);
